import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import GenderSelect from './GenderSelect';

interface Props extends BaseFieldProps {
	valueKey?: 'id';
}

const GenderSelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<GenderSelect valueKey={props.valueKey} />
	</BaseField>
);

export default GenderSelectField;
